import flowValveApi from '@/api/config/flowValveApi'
import { queryKeys } from '@/constant/common'
import { FormRestIdFlowValve } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { getApiErrorMessage } from '@/helpers'

async function resetFlowValve({ interfaceId, id }: FormRestIdFlowValve) {
  await flowValveApi.resetErrorById(interfaceId, id)
}

function useResetIdFlowValve() {
  const queryClient = useQueryClient()

  return useMutation((params: FormRestIdFlowValve) => resetFlowValve(params), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.flowValveError])
      toast.success('Reset All FlowValve Success')
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useResetIdFlowValve
